import { render } from "./BaseAlert.vue?vue&type=template&id=282ededd"
import script from "./BaseAlert.vue?vue&type=script&lang=js"
export * from "./BaseAlert.vue?vue&type=script&lang=js"

import "./BaseAlert.vue?vue&type=style&index=0&id=282ededd&lang=scss"

import exportComponent from "/builds/anteup/anteup-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__